module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_pn-3e6900c3498662ccd96e0a51bd897ba9.gif";